import moment from 'moment';
import store from 'store';
import {
    MetaDto,
    ProspectConversationDto,
    ProspectConversationsDto,
    ProspectChatDto,
    ProspectDto,
    ProspectMessageDto,
    MessageDto
} from './prospectMessageDtos';
import {
    Message,
    Meta,
    Prospect,
    ProspectConversation,
    ProspectConversationDetail,
    ProspectConversations,
    ProspectMessage
} from 'model/ProspectMessage';
import { SmsMessage } from 'model/TwoWaySms';
import { SmsMessageDto } from 'actions/twoWaySms/twoWaySmsDtos';
import { convertToSmsMessage } from 'actions/twoWaySms/twoWaySmsConverter';

export const convertToProspectMessage = (prospectMessageDto: ProspectMessageDto): ProspectMessage => {
    const timeZone = store.getState().marketplace.marketplace.schedule.timeZone;

    return {
        id: prospectMessageDto.id,
        uuid: prospectMessageDto.uuid ?? '',
        marketplaceId: prospectMessageDto.marketplace_id,
        prospectId: prospectMessageDto.prospect_id,
        senderId: prospectMessageDto.sender_id,
        senderType: prospectMessageDto.sender_type,
        receiverId: prospectMessageDto.receiver_id,
        receiverType: prospectMessageDto.receiver_type,
        message: prospectMessageDto.message,
        sentAt: prospectMessageDto.sent_at,
        receivedAt: prospectMessageDto.received_at,
        readAt: prospectMessageDto.read_at,
        createdAt: moment(prospectMessageDto.created_at).tz(timeZone)
    };
};

export const convertToProspectConversations = (
    prospectConversationDto: ProspectConversationsDto
): ProspectConversations => {
    return {
        prospectConversations: convertToProspectConversation(prospectConversationDto.prospect_conversations),
        meta: convertToMeta(prospectConversationDto.meta)
    };
};

export const convertToProspect = (prospectDto: ProspectDto): Prospect => {
    return {
        id: prospectDto.id,
        uuid: prospectDto.uuid,
        phone: prospectDto.phone
    };
};

export const convertToMeta = (metaDto: MetaDto): Meta => {
    return {
        page: parseInt(metaDto.current_page as any, 10),
        size: parseInt(metaDto.per_page as any, 10),
        totalEntries: parseInt(metaDto.total_entries as any, 10),
        totalPages: parseInt(metaDto.total_pages as any, 10)
    };
};

export const convertToProspectConversation = (
    prospectConversations: Array<ProspectConversationDto>
): Array<ProspectConversation> => {
    return prospectConversations.map(prospectConversation => {
        return {
            prospect: convertToProspect(prospectConversation.prospect),
            totalMessages: prospectConversation.total_message,
            unreadMessages: prospectConversation.unread_messages,
            lastMessage: convertToProspectMessage(prospectConversation.last_message)
        };
    });
};

export const convertToProspectConversationDetail = (prospectChatDto: ProspectChatDto): ProspectConversationDetail => {
    return {
        prospect: convertToProspect(prospectChatDto.prospect),
        unreadMessages: prospectChatDto.unread_messages,
        lastMessage: convertToProspectMessage(prospectChatDto.last_message),
        messages: prospectChatDto.messages.map(message => convertToProspectMessage(message)),
        meta: convertToMeta(prospectChatDto.meta)
    };
};

export const convertToProspectMessageDto = (prospectMessage: ProspectMessage): ProspectMessageDto => {
    return {
        id: prospectMessage.id,
        uuid: prospectMessage.uuid,
        marketplace_id: prospectMessage.marketplaceId,
        prospect_id: prospectMessage.prospectId,
        sender_id: prospectMessage.senderId,
        sender_type: prospectMessage.senderType,
        receiver_id: prospectMessage.receiverId,
        receiver_type: prospectMessage.receiverType,
        message: prospectMessage.message,
        sent_at: prospectMessage.sentAt,
        read_at: prospectMessage.readAt
    };
};

export const convertMessage = (messageDto: MessageDto): Message => {
    let message: SmsMessage | ProspectMessage;

    if (messageDto.type === 'customer') {
        const smsMessageDto = messageDto.message as SmsMessageDto;
        message = convertToSmsMessage(smsMessageDto);
    } else {
        const prospectMessageDto = messageDto.message as ProspectMessageDto;
        message = convertToProspectMessage(prospectMessageDto);
    }

    return {
        id: messageDto.id,
        phone: messageDto.phone,
        type: messageDto.type,
        message
    };
};
